// Role
import {
  ROLE_FORM_CLEAR,
  ROLE_FORM_FETCH_REQUEST,
  ROLE_FORM_FETCH_RESPONSE_ERROR,
  ROLE_FORM_FETCH_RESPONSE_SUCCESS,
  ROLE_FORM_INIT_REQUEST,
  ROLE_FORM_INIT_RESPONSE_ERROR,
  ROLE_FORM_INIT_RESPONSE_SUCCESS,
  ROLE_FORM_SUBMIT_REQUEST,
  ROLE_FORM_SUBMIT_RESPONSE_ERROR,
  ROLE_FORM_SUBMIT_RESPONSE_SUCCESS,
  ROLE_GRID_CHANGE_FILTER,
  ROLE_GRID_CHANGE_PAGINATION,
  ROLE_GRID_CHANGE_SORT,
  ROLE_GRID_DELETE_REQUEST,
  ROLE_GRID_DELETE_RESPONSE_ERROR,
  ROLE_GRID_DELETE_RESPONSE_SUCCESS,
  ROLE_GRID_FETCH_REQUEST,
  ROLE_GRID_FETCH_RESPONSE_ERROR,
  ROLE_GRID_FETCH_RESPONSE_SUCCESS,
} from "../constants/actionTypes";

const initialState = {
  formData: {},
  formDataPermissions: [],
  formErrors: [],
  formIsFetching: false,
  formIsInitializing: false,
  formIsSubmitting: false,
  gridData: [],
  gridDataTotal: 0,
  gridIsDeleting: false,
  gridErrors: [],
  gridIsFetching: false,
  gridFilters: [],
  gridPage: 1,
  gridPageSize: 10,
  gridSortField: "name",
  gridSortOrder: "asc",
};

const role = (state = initialState, action) => {
  switch (action.type) {
    // FORM - Clear
    case ROLE_FORM_CLEAR:
      return {
        ...state,
        formData: {},
        formDataPermissions: [],
        formErrors: [],
        formIsFetching: false,
        formIsInitializing: false,
        formIsSubmitting: false,
      };

    // FORM - Fetch
    case ROLE_FORM_FETCH_REQUEST:
      return {
        ...state,
        formData: {},
        formErrors: [],
        formIsFetching: true,
      };
    case ROLE_FORM_FETCH_RESPONSE_ERROR:
      return {
        ...state,
        formErrors: action.payload,
        formIsFetching: false,
      };
    case ROLE_FORM_FETCH_RESPONSE_SUCCESS:
      return {
        ...state,
        formData: action.payload,
        formIsFetching: false,
      };

    // FORM - Init
    case ROLE_FORM_INIT_REQUEST:
      return {
        ...state,
        formIsInitializing: true,
      };
    case ROLE_FORM_INIT_RESPONSE_ERROR:
      return {
        ...state,
        formDataPermissions: [],
        formIsInitializing: false,
      };
    case ROLE_FORM_INIT_RESPONSE_SUCCESS:
      return {
        ...state,
        formDataPermissions: action.payload.permissions,
        formIsInitializing: false,
      };

    // FORM - Submit
    case ROLE_FORM_SUBMIT_REQUEST:
      return {
        ...state,
        formIsSubmitting: true,
      };
    case ROLE_FORM_SUBMIT_RESPONSE_ERROR:
      return {
        ...state,
        formErrors: action.payload,
        formIsSubmitting: false,
      };
    case ROLE_FORM_SUBMIT_RESPONSE_SUCCESS:
      return {
        ...state,
        formErrors: [],
        formIsSubmitting: false,
      };

    // GRID - Change - Filter
    case ROLE_GRID_CHANGE_FILTER:
      return {
        ...state,
        gridFilters: action.payload.filters,
      };

    // GRID - Change - Pagination
    case ROLE_GRID_CHANGE_PAGINATION:
      return {
        ...state,
        gridPage: action.payload.page,
        gridPageSize: action.payload.pageSize,
      };

    // GRID - Change - Sort
    case ROLE_GRID_CHANGE_SORT:
      return {
        ...state,
        gridSortField: action.payload.sortField,
        gridSortOrder: action.payload.sortOrder,
      };

    // GRID - Delete
    case ROLE_GRID_DELETE_REQUEST:
      return {
        ...state,
        gridIsDeleting: true,
      };
    case ROLE_GRID_DELETE_RESPONSE_ERROR:
      return {
        ...state,
        gridData: [],
        gridDataTotal: 0,
        gridIsDeleting: false,
        gridErrors: action.payload,
      };
    case ROLE_GRID_DELETE_RESPONSE_SUCCESS:
      return {
        ...state,
        gridIsDeleting: false,
        gridErrors: [],
      };

    // GRID - Fetch
    case ROLE_GRID_FETCH_REQUEST:
      return {
        ...state,
        gridIsFetching: true,
      };
    case ROLE_GRID_FETCH_RESPONSE_ERROR:
      return {
        ...state,
        gridData: [],
        gridDataTotal: 0,
        gridErrors: action.payload,
        gridIsFetching: false,
      };
    case ROLE_GRID_FETCH_RESPONSE_SUCCESS:
      return {
        ...state,
        gridData: action.payload.data,
        gridDataTotal: action.payload.total,
        gridErrors: [],
        gridIsFetching: false,
      };
    default:
      return state;
  }
};

export default role;
